/* eslint-disable react/prop-types */
import { Minus, Plus } from "lucide-react";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import ErrorBoundary from "../common/ErrorBoundary";
import { Skeleton } from "../ui/skeleton";
import { FaXmark } from "react-icons/fa6";
import { LuListX } from "react-icons/lu";
import { IoFastFoodOutline } from "react-icons/io5";
import toast from "react-hot-toast";
import { DefaultDialog } from "../dialog/default-dialog";
import useAuth from "@/hooks/useAuth";
import useSettings from "@/hooks/useSettings";
import { addPerson, removePerson, setCourseItems, moveItemsToPerson, movePersonItemsToCourseItems, movePersonItemToCourseItems, updatePersonName, emptyCourseWisePayState, addCourseWisePayPersonPaymentSlot, setCourseWisePayPersonTips, setCourseWisePayTotals, setInitialCourseWisePayState, markCourseWisePayAsComplete, setCourseWisePayToReduxState } from "@/redux/slice/take-order-slice/course-wise-pay";
import { v4 as uuidv4 } from "uuid";
import { getCourseWisePaymentApi, updateCourseWisePaymentApi } from "@/api/take-order/take-order";
import { setOrderData } from "@/redux/slice/take-order-slice/order-slice";
import { printCourseWisePaymentCopy } from "@/lib/print-slip";
import PusherHandler from "@/api/lib/pusher/PusherHandler";
import TipsCourseWiseAndSplit from "./tipsCourseWiseAndSplit";
import SplitCardPaymentConfirmDialog from "./SplitCardPaymentConfirmDialog";
import OrderCardPaymentResponseDialog from "./OrderCardPaymentResponseDialog";
import PaxPaymentTimeoutDialog from "./PaxPaymentTimeoutDialog";
import getOrderAdvanceDetails from "@/lib/orderAdvanceUtils";

function CourseWisePay({ setCourseWisePay }) {
    const dispatch = useDispatch();
    const { totalAmount, totalToPay, totalServiceCharge, receivedAmount, remainingAmount, persons, courseItems, id, is_complete , isLoading } = useSelector((state) => state.CourseWisePay);
    const { orderData } = useSelector((state) => state.takeOrder.order);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cashReceived, setCashReceived] = useState(0);
    const [cashAmount, setCashAmount] = useState(0);
    const [activePaymentId, setActivePaymentId] = useState(null);
    const { user } = useAuth();
    const { settings } = useSettings();
    const { addEventHandler, removeEventHandler } = PusherHandler();
    const restaurant_id = user?.restaurant_id;
    const [personCoursesModalOpen, setPersonCoursesModalOpen] = useState(false);
    const [selectedPersonForCourses, setSelectedPersonForCourses] = useState(null);
    const [personDropdownOpen, setPersonDropdownOpen] = useState(false);
    const [selectedPersonId, setSelectedPersonId] = useState("");
    const [selectedCourseItems, setSelectedCourseItems] = useState([]);
    const [tabPayStep, setTabPayStep] = useState(1); // "person_courses" or "payment_details"
    const [isTabletView, setIsTabletView] = useState(window.innerWidth <= 1280);

    const [cardConfirmPerson, setCardConfirmPerson] = useState(null);
    const [cardChargeAmount, setCardChargeAmount] = useState(0);
    const [sentCardAmount, setSentCardAmount] = useState(0);
    const [isCardLoading, setIsCardLoading] = useState(false);
    const [cardResponseData, setCardResponseData] = useState(null);
    const [isCardResponseOpen, setIsCardResponseOpen] = useState(false);
    const [isPaxTimeoutDialogOpen, setIsPaxTimeoutDialogOpen] = useState(false);
    const [paxTimeoutData, setPaxTimeoutData] = useState(null);

    const [tipsFor, setTipsFor] = useState(null);
    const [tipType, setTipType] = useState("percentage");
    const [amount, setAmount] = useState("0");
    // const [isPaymentComplete, setIsPaymentComplete] = useState(is_complete);    

    const personDropdownRef = useRef(null);


    function withVat(price, vat){
        
        const settings = JSON.parse(localStorage.getItem("settings") || null);

        if(settings && settings?.take_order?.vat_settings && settings?.take_order?.vat_settings?.is_vat_enabled && settings?.take_order?.vat_settings?.type){
            const vatType = settings?.take_order?.vat_settings?.type 
            if(vatType == "exclusive"){
                return(Number.parseFloat(price) + Number.parseFloat(vat))
            }else{
                return(Number.parseFloat(price))
            }
        }else{
            return(Number.parseFloat(price))
        }
    }


    console.log(orderData, "orderData in course wise pay component");

    useEffect(() => {
        function handleDocumentClick(e) {
            if (personDropdownRef.current && !personDropdownRef.current.contains(e.target)) {
                setPersonDropdownOpen(false);
            }
        }
        document.addEventListener("click", handleDocumentClick);
        return () => document.removeEventListener("click", handleDocumentClick);
    }, []);

    useEffect(() => {
        const advanceInfo = getOrderAdvanceDetails(orderData);
        const hasAdvanceDeposit = Boolean(
            (advanceInfo?.isPaid && advanceInfo?.advanceAmount > 0) ||
            (Number(orderData?.advance || 0) > 0 && orderData?.advance_payment?.status === "paid") ||
            (Boolean(orderData?.reservation?.is_deposit_paid) && Number(orderData?.reservation?.advance || 0) > 0)
        );
        if (hasAdvanceDeposit) {
            toast.error("Course Wise Pay is not available for orders with an advance deposit.");
            dispatch(emptyCourseWisePayState());
            setCourseWisePay(false);
        }
    }, [orderData, dispatch, setCourseWisePay]);


    // useEffect(() => {
    //     dispatch(setCourseWisePayTotals({ totalSavings: Number(parseFloat(orderData?.total_savings || 0).toFixed(2))  || 0, totalServiceCharge: Number(parseFloat(orderData?.service_charge_amount || 0).toFixed(2)) }));
    // }, [dispatch, orderData]);

    useEffect(() => {
        // Expand items so each unit in quantity becomes a separate item with quantity = 1
        function expandItems(items = []) {
            const result = [];
            items.forEach((item) => {
                const qty = item.quantity || 1;
                for (let i = 0; i < qty; i++) {
                    result.push({
                        ...item,
                        quantity: 1,
                        front_item_id: uuidv4(), // Unique ID for each unit
                    });
                }
            });
            return result;
        }

        console.log("orderData items:", orderData?.items);
        const expanded = expandItems(orderData?.items || []);
        console.log("expanded course items:", expanded);

        dispatch(setCourseWisePayTotals({ totalSavings: Number(parseFloat(orderData?.total_savings || 0).toFixed(2))  || 0, totalServiceCharge: Number(parseFloat(orderData?.service_charge_amount || 0).toFixed(2)) }));

        dispatch(setCourseItems(expanded));

    }, []);




    function toggleSelectCourseItem(item) {
        setSelectedCourseItems((prevSelected) => {
            const exists = prevSelected.some(si => si.front_item_id === item.front_item_id);
            if (exists) {
                return prevSelected.filter(si => si.front_item_id !== item.front_item_id);
            } else {
                return [...prevSelected, item];
            }
        });
    }

    console.log("selectedCourseItems:-->>", selectedCourseItems);


    function assignItemsToPerson() {
        if (is_complete) {
            toast.error("Payment is already completed. No further changes allowed.");
            return;
        }

        if (!selectedPersonId) {
            toast.error("Please select a person to assign items.");
            return;
        }

        if (selectedCourseItems.length === 0) {
            toast.error("No items selected to assign.");
            return;
        }

        // Dispatch move to redux
        dispatch(moveItemsToPerson({ personId: selectedPersonId, items: selectedCourseItems }));

        // Clear local selection and notify
        setSelectedCourseItems([]);
        
    }

    // Current person for the modal is derived from the store so it reflects changes after dispatches
    const personForModal = selectedPersonForCourses ? persons.find(p => p.id === selectedPersonForCourses.id) : null;





    function saveCourseWisePay() {
        if (is_complete) {
            toast.error("Payment is already completed. No further changes allowed.");
            return;
        }


        const payload = {
            id: id || null,
            restaurant_id,
            order_id: orderData.id,
            courseItems : courseItems.map(item => ({
                front_item_id: item.front_item_id,
                order_id: item.order_id,
                order_item_id: item.order_item_id,
                menu_item_id: item.menu_item_id,
                quantity: item.quantity,
                variant: {
                    id: item?.variant?.id || null,
                    name: item?.variant?.name || null,
                },
                buffet_price_for: item?.buffet_price_for || null,
                size: item?.size || null,
            })),
            persons : persons.map(person => ({
                person_id: person.id,
                name: person.name,
                courses: person.courses.map(course => ({
                    front_item_id: course.front_item_id,
                    order_id: course.order_id,
                    order_item_id: course.order_item_id,
                    menu_item_id: course.menu_item_id,
                    quantity: course.quantity,
                    variant: {
                        id: course?.variant?.id || null,
                        name: course?.variant?.name || null,
                    },
                    buffet_price_for: course?.buffet_price_for || null,
                    size: course?.size || null,
                })),
                amountToPay: person.amountToPay,
                tips: person.tips || null,
                slots: Array.isArray(person.slots) ? person.slots.map(s => ({
                    ...(s.id !== undefined && s.id !== null ? { id: s.id } : {}),
                    method: s.method || "Cash",
                    amount: Number(parseFloat(s.amount).toFixed(2)),
                    received: s.received !== undefined && s.received !== null ? Number(parseFloat(s.received).toFixed(2)) : Number(parseFloat(s.amount).toFixed(2)),
                    changed: s.changed !== undefined ? (s.changed !== null ? Number(parseFloat(s.changed).toFixed(2)) : null) : (s.change !== undefined ? (s.change !== null ? Number(parseFloat(s.change).toFixed(2)) : null) : null),
                    reference: s.reference !== undefined ? s.reference : null,
                })) : [],
            })),
            total_amount: totalAmount,
            received_amount: receivedAmount,
            remaining_amount: remainingAmount,
        };


        console.log("Saving Course Wise Pay with payload:", payload);


        updateCourseWisePaymentApi(restaurant_id, orderData.id, payload)
        .then((res) => {
            if (res.status === "success") {
                console.log("Course Wise Pay saved successfully:", res);
                dispatch(setCourseWisePayToReduxState(res?.data?.course_wise_payment)); 
                dispatch(setOrderData(res?.data?.order));
                if(res?.data?.is_payment_completed || Number(res?.data?.remaining_amount) == 0){
                    dispatch(markCourseWisePayAsComplete());
                    toast.success("Course Wise Pay marked as complete.");
                    setCourseWisePay(false);
                    dispatch(emptyCourseWisePayState());
                }else{
                    toast.success("Course Wise Pay saved successfully.");
                }
            }else{
                console.error("Failed to save Course Wise Pay:", res);
                toast.error( res?.message || "Failed to save Course Wise Pay. Please try again.");
            }
        })
        .catch((err) => {
            console.error("Error saving Course Wise Pay:", err);
            toast.error("Failed to save Course Wise Pay. Please try again.");
        });

        // download the payload as a JSON file for inspection
        // const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
        // const url = URL.createObjectURL(blob);
        // const a = document.createElement("a");
        // a.href = url;
        // a.download = `course_wise_pay_payload_order_${orderData.id}.json`;
        // a.click();
        // URL.revokeObjectURL(url);
        // toast.success("Course Wise Pay data saved (check downloaded JSON).");

    }


    // useEffect(() => {

    //     getCourseWisePaymentApi(restaurant_id, orderData.id)
    //     .then((res) => {
    //         if (res.status === "success" && res.data) {
    //             const data = res.data;
    //             dispatch(setInitialCourseWisePayState(data));
    //             console.log("Fetched Course Wise Pay data:", data);
    //         }else{
    //             console.error("Failed to fetch Course Wise Pay data:", res);
    //             toast.error( res?.message || "Failed to fetch Course Wise Pay data. Please try again.");
    //         }
    //     }).catch((err) => {
    //         console.error("Error fetching Course Wise Pay data:", err);
    //         toast.error("Failed to fetch Course Wise Pay data. Please try again.");
    //     });
    // }, []);


    const handleOpenCardModal = (person) => {
        if (is_complete) {
            toast.error("Payment is already completed. No further changes allowed.");
            return;
        }

        const totalSlotAmount = (person.slots || []).reduce((sum, slot) => sum + (parseFloat(slot.amount) || 0), 0);
        const personDue = Math.max(0, parseFloat(person.amountToPay || 0) - parseFloat(person.savingsAmount || 0));
        const remainingDue = Math.max(0, Math.round((personDue - totalSlotAmount) * 100) / 100);

        if (remainingDue <= 0) {
            toast.error(`${person.name} is already fully paid.`);
            return;
        }

        setCardConfirmPerson(person);
        setCardChargeAmount(remainingDue);
    };

    const handleDispatchCardPayment = async (selectedAmount) => {
        if (!cardConfirmPerson) return;
        if (!restaurant_id || !orderData?.id) {
            toast.error("Restaurant or Order ID missing.");
            return;
        }

        const amountToPay = selectedAmount || cardChargeAmount;
        if (!amountToPay || amountToPay <= 0) {
            toast.error("Please enter a valid amount.");
            return;
        }

        setSentCardAmount(Number(parseFloat(amountToPay).toFixed(2)));
        setIsCardLoading(true);
        try {
            const updatedPersons = persons.map((person) => {
                const isTargetPerson = person.id === cardConfirmPerson.id;
                const existingSlots = Array.isArray(person.slots) ? person.slots.map((s) => ({
                    ...(s.id !== undefined && s.id !== null ? { id: s.id } : {}),
                    method: s.method || "Card",
                    amount: Number(parseFloat(s.amount).toFixed(2)),
                    received: s.received !== undefined && s.received !== null ? Number(parseFloat(s.received).toFixed(2)) : Number(parseFloat(s.amount).toFixed(2)),
                    changed: s.changed !== undefined ? (s.changed !== null ? Number(parseFloat(s.changed).toFixed(2)) : null) : (s.change !== undefined ? (s.change !== null ? Number(parseFloat(s.change).toFixed(2)) : null) : null),
                    reference: s.reference !== undefined ? s.reference : null,
                })) : [];

                const newSlots = isTargetPerson
                    ? [
                        ...existingSlots,
                        {
                            method: "Card",
                            amount: Number(parseFloat(amountToPay).toFixed(2)),
                        }
                    ]
                    : existingSlots;

                return {
                    person_id: person.id,
                    name: person.name,
                    courses: person.courses.map((course) => ({
                        front_item_id: course.front_item_id,
                        order_id: course.order_id,
                        order_item_id: course.order_item_id,
                        menu_item_id: course.menu_item_id,
                        quantity: course.quantity,
                        variant: {
                            id: course?.variant?.id || null,
                            name: course?.variant?.name || null,
                        },
                        buffet_price_for: course?.buffet_price_for || null,
                        size: course?.size || null,
                    })),
                    amountToPay: person.amountToPay,
                    tips: person.tips || null,
                    slots: newSlots,
                };
            });

            const newReceivedAmount = updatedPersons.reduce((total, p) =>
                total + p.slots.reduce((slotSum, s) => slotSum + Number(s.amount || 0), 0), 0
            );
            const newRemainingAmount = Math.max(0, Math.round((Number(totalAmount) - newReceivedAmount) * 100) / 100);

            const payload = {
                id: id || null,
                restaurant_id,
                order_id: orderData.id,
                courseItems: courseItems.map((item) => ({
                    front_item_id: item.front_item_id,
                    order_id: item.order_id,
                    order_item_id: item.order_item_id,
                    menu_item_id: item.menu_item_id,
                    quantity: item.quantity,
                    variant: {
                        id: item?.variant?.id || null,
                        name: item?.variant?.name || null,
                    },
                    buffet_price_for: item?.buffet_price_for || null,
                    size: item?.size || null,
                })),
                persons: updatedPersons,
                total_amount: totalAmount,
                received_amount: Number(newReceivedAmount.toFixed(2)),
                remaining_amount: Number(newRemainingAmount.toFixed(2)),
            };

            console.log("Dispatching Course Wise Card Payment with payload:", payload);

            const response = await updateCourseWisePaymentApi(restaurant_id, orderData.id, payload);

            console.log("Course Wise Card Payment Response --->", response);

            if (response?.status === "success") {
                toast.success(response?.message || "Payment processed successfully.");

                if (response?.data?.course_wise_payment) {
                    dispatch(setCourseWisePayToReduxState(response.data.course_wise_payment));
                }
                if (response?.data?.order) {
                    dispatch(setOrderData(response.data.order));
                }

                if (response?.data?.is_payment_completed || Number(response?.data?.remaining_amount) === 0) {
                    dispatch(markCourseWisePayAsComplete());
                    toast.success("Course Wise Pay marked as complete.");
                    setCourseWisePay(false);
                    dispatch(emptyCourseWisePayState());
                }

                setCardResponseData(response);
                setIsCardResponseOpen(true);
                setCardConfirmPerson(null);
            } else {
                toast.error(response?.message || "Failed to process card payment.");
            }
        } catch (error) {
            console.error("Error processing course-wise card payment:", error);
            toast.error("Failed to process card payment. Please try again.");
        } finally {
            setIsCardLoading(false);
        }
    };

    // Real-time Pusher listener for order/course-wise payment updates
    useEffect(() => {
        const handleOrderUpdated = (data) => {
            console.log("Course-wise payment Pusher event [order-updated]:", data);
            if (!data || Number(data.order_id) !== Number(orderData?.id)) return;

            if (
                (data.type === "course_wise_payment_updated" || data.type === "course_wise_payment_paid" || data.type === "terminal_payment_approved") &&
                data.course_wise_payment
            ) {
                toast.success("Course-wise card payment confirmed successfully!");
                setIsCardLoading(false);
                setIsCardResponseOpen(false);
                setCardResponseData(null);
                setCardConfirmPerson(null);
                setSentCardAmount(0);
                setIsPaxTimeoutDialogOpen(false);
                setPaxTimeoutData(null);

                dispatch(setCourseWisePayToReduxState(data.course_wise_payment));

                if (orderData) {
                    const incomingPayment = data.payment || orderData.payment;
                    dispatch(setOrderData({
                        ...orderData,
                        payment_status: data.payment_status || orderData.payment_status,
                        stage: data.stage || orderData.stage,
                        kitchen_status: data.kitchen_status || orderData.kitchen_status,
                        cooking_time: data.cooking_time ?? orderData.cooking_time,
                        cooking_time_set_at: data.cooking_time_set_at ?? orderData.cooking_time_set_at,
                        payment: incomingPayment,
                        tips: incomingPayment?.tips ?? data.tips ?? orderData.tips,
                        tips_amount: incomingPayment?.tips_amount ?? data.tips_amount ?? orderData.tips_amount,
                        tip_type: incomingPayment?.tip_type ?? data.tip_type ?? orderData.tip_type,
                        total_price: data.total_price ?? (incomingPayment?.amount ? incomingPayment.amount : orderData.total_price),
                    }));
                }

                if (data.payment_status === "paid" || Number(data.course_wise_payment?.remaining_amount) <= 0) {
                    dispatch(markCourseWisePayAsComplete());
                    setCourseWisePay(false);
                    dispatch(emptyCourseWisePayState());
                }
            } else if (
                data.type === "order_payment_timeout" ||
                data.type === "course_wise_payment_timeout" ||
                data.type === "terminal_payment_timeout"
            ) {
                if (data.course_wise_payment) {
                    dispatch(setCourseWisePayToReduxState(data.course_wise_payment));
                }
                if (orderData) {
                    dispatch(setOrderData({
                        ...orderData,
                        payment_status: data.payment_status || orderData.payment_status,
                        stage: data.stage || orderData.stage,
                        kitchen_status: data.kitchen_status || orderData.kitchen_status,
                        cooking_time: data.cooking_time ?? orderData.cooking_time,
                        cooking_time_set_at: data.cooking_time_set_at ?? orderData.cooking_time_set_at,
                        payment: data.payment || null,
                    }));
                }
                setIsCardLoading(false);
                setIsCardResponseOpen(false);
                setCardResponseData(null);
                setCardConfirmPerson(null);
                setSentCardAmount(0);
                setPaxTimeoutData(data);
                setIsPaxTimeoutDialogOpen(true);
                toast.error("PAX terminal payment timed out.");
            } else if (
                data.type === "course_wise_payment_failed" ||
                data.type === "course_wise_payment_cancelled"
            ) {
                toast.error(data?.message || "Course-wise card payment cancelled.");
                setIsCardLoading(false);
                setIsCardResponseOpen(false);
                setCardResponseData(null);
                setCardConfirmPerson(null);
                setSentCardAmount(0);
                setIsPaxTimeoutDialogOpen(false);
                setPaxTimeoutData(null);
            }
        };

        const unsubscribe = addEventHandler("order-updated", handleOrderUpdated);
        return () => {
            if (typeof unsubscribe === "function") {
                unsubscribe();
            } else {
                removeEventHandler("order-updated", handleOrderUpdated);
            }
        };
    }, [addEventHandler, removeEventHandler, orderData, dispatch, setCourseWisePay]);

    function saveTipsInfo(tipsAmount) {
        if (is_complete) {
            toast.error("Payment is already completed. No further changes allowed.");
            return;
        }

        const person = persons.find(p => p.id === tipsFor);
        if (!person) {
            toast.error("Please select a person for tips.");
            return;
        }

        const inputAmount = Number(parseFloat(tipsAmount || 0).toFixed(2));
        const baseAmount = Number(
            parseFloat((person.amountToPay || 0) - (person.tips?.amount || 0)).toFixed(2)
        );

        const calculatedAmount = tipType === "percentage"
            ? Number(((baseAmount * inputAmount) / 100).toFixed(2))
            : inputAmount;

        dispatch(setCourseWisePayPersonTips({
            personId: person.id,
            tips: {
                type: tipType,
                inputAmount,
                amount: calculatedAmount,
            },
        }));
    }


    // const totalServiceCharge = Number(parseFloat(orderData?.service_charge_amount || 0).toFixed(2));
    const serviceChargePerPerson = Number((totalServiceCharge / persons.length).toFixed(2));

    console.log("tipsFor: ", tipsFor, " tipType: ", tipType, " amount: ", amount);


    function calculateTotalTips(persons) {
        return persons.reduce((total, person) => {
            return total + (person.tips?.amount || 0);
        }, 0);
    }


    return (
        <ErrorBoundary>
            {isLoading ? (
                <div className={` ${isTabletView ? "w-[600px] h-[650px]" : "w-[1390px] h-[730px]"} bg-color2 p-6 rounded-md border-2 border-color3 shadow-2xl text-white flex flex-col gap-4`}>
                    <div className="flex items-center justify-center">
                        <Skeleton className="h-8 w-64 mb-2" />
                    </div>

                    <div className="w-full flex items-start gap-4">
                        <div className=" w-[33.33%] h-full pt-6 px-4 bg-color3">
                            <Skeleton className="h-6 w-40 mb-4" />
                            <div className="flex items-center justify-center gap-2 mb-4">
                                <Skeleton className="h-12 w-12 rounded-full" />
                                <Skeleton className="h-10 w-28" />
                                <Skeleton className="h-10 w-10" />
                            </div>
                            <Skeleton className="h-6 w-32 mb-3" />
                            <div className={`space-y-2 mt-2 ${isTabletView ? "h-[230px]" : "h-[350px]"} overflow-hidden`}>
                                {Array.from({ length: 6 }).map((_, i) => (
                                    <Skeleton key={i} className="h-10 w-full" />
                                ))}
                            </div>
                            <div className="mt-2">
                                <Skeleton className="h-10 w-full mt-2" />
                            </div>
                        </div>

                        <div className=" w-[33.33%] h-full pt-6 px-4 bg-color3">
                            <Skeleton className="h-6 w-48 mb-4" />
                            <div className={` w-full ${isTabletView ? "h-[200px]" : "h-[530px]"} overflow-hidden p-2`}>
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div key={i} className="w-full flex flex-col bg-color2 items-center gap-4 mb-6 p-3 rounded-md relative">
                                        <Skeleton className="h-8 w-full mb-2" />
                                        <div className=" w-full flex gap-2">
                                            <Skeleton className="h-10 w-full" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="w-[33.33%] flex flex-col">
                            <div className="flex items-center justify-between text-center mb-4 border-b-2 border-dashed border-color3 pb-4">
                                <Skeleton className="h-6 w-40" />
                                <Skeleton className="h-6 w-24" />
                            </div>
                            <div className="flex items-center justify-between text-center mb-4 border-b-2 border-dashed border-color3 pb-4">
                                <Skeleton className="h-6 w-28" />
                                <Skeleton className="h-6 w-24" />
                            </div>
                            <div className="flex items-center justify-between text-center mb-4 ">
                                <Skeleton className="h-6 w-28" />
                                <Skeleton className="h-6 w-24" />
                            </div>
                            <div className={` w-full ${isTabletView ? "h-[200px]" : "h-[420px]"} pr-2 overflow-hidden flex flex-col gap-4 `}>
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <Skeleton key={i} className="h-12 w-full" />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-4 mt-2">
                        <Skeleton className="h-10 w-full" />
                        <Skeleton className="h-10 w-full" />
                    </div>
                </div>
            ) : (
            <div className={` ${isTabletView ? "w-[600px] h-[640px]" : "w-[1390px] h-[720px]"} bg-color2 ${isTabletView ? "p-4" : "p-6"} rounded-md border-2 border-color3 shadow-2xl text-white flex flex-col ${isTabletView ? "gap-2" : "gap-3"}`}>
                <h2 className={`${isTabletView ? "text-xl" : "text-2xl"} font-semibold text-center ${isTabletView ? "-mt-2 mb-1" : "-mt-4"} uppercase`}>Course-Wise Pay {is_complete && <span className=" text-color7"> (Completed)</span>} </h2> 
                {
                    isTabletView && (
                        <div className="w-full flex items-center justify-center gap-4 mb-1">
                            <button onClick={()=> setTabPayStep(1)} className={`px-5 py-2.5 text-sm font-medium ${tabPayStep === 1 ? "bg-color6 text-color1" : "bg-color3 text-color5"} rounded-md transition-colors`}>Person & Courses</button>
                            <div className="px-3 text-color6 font-semibold text-sm">{"<"}-----------{">"}</div>
                            <button onClick={()=> setTabPayStep(2)} className={`px-5 py-2.5 text-sm font-medium ${tabPayStep === 2 ? "bg-color6 text-color1" : "bg-color3 text-color5"} rounded-md transition-colors`} >Payment & Details</button>
                        </div>)
                }
                
                <div className={`w-full flex items-stretch justify-center ${isTabletView ? "gap-3" : "gap-4"} overflow-hidden`}>
                    <div className={` ${(isTabletView) ? "w-full" : "w-[33.33%] h-full"} ${(isTabletView && tabPayStep === 2) ? "hidden h-full" : "block h-full"} ${isTabletView ? "pt-4 px-3" : "pt-4 px-4 pb-4"} bg-color3 rounded-md`}>
                        <div className={`${isTabletView ? "-mt-2" : "-mt-2"}`}>
                            <p className={`font-medium text-center uppercase ${isTabletView ? "text-sm" : "text-base"}`}>Number Of Persons </p>
                        </div>
                        <div className={`flex items-center justify-center gap-1 ${isTabletView ? "mb-2 mt-2" : "mb-3 mt-3"}`}>
                            <span className={`px-4 ${isTabletView ? "text-3xl" : "text-4xl"} font-bold`}>{persons.length}</span>
                            <button
                                onClick={() =>{ 

                                    if (is_complete) {
                                        toast.error("Payment is already completed. No further changes allowed.");
                                        return;
                                    }
                                    if (courseItems.length === 0) {
                                        toast.error("Cannot add person when there are no course items.");
                                        return;
                                    }
                                    dispatch(addPerson());
                                }}
                                className="px-1   bg-color12 text-5xl text-white rounded-md hover:bg-gray-600"
                            >
                                <Plus size={28} />
                            </button>
                        </div>
                        <div ref={personDropdownRef} className="relative">
                            <button
                                type="button"
                                onClick={() => setPersonDropdownOpen(!personDropdownOpen)}
                                className={`w-full ${isTabletView ? "p-2 text-sm" : "p-2"} bg-color2 border border-gray-600 rounded-md outline-none focus:border-gray-400 text-left`}
                            >
                                {selectedPersonId ? (persons.find(p => p.id === selectedPersonId)?.name || "Select Person") : "Select Person"}
                            </button>

                            {personDropdownOpen && (
                                <div className=" absolute z-30 mt-1 w-full bg-color3 border border-gray-600 rounded-md max-h-48 overflow-y-auto">
                                    {persons.map((person) => (
                                        <div
                                            key={person.id}
                                            className=" p-2 flex justify-between items-center hover:bg-gray-700 cursor-pointer"
                                            onClick={() => { setSelectedPersonId(person.id); setPersonDropdownOpen(false); }}
                                        >
                                            <div className=" w-[180px]">
                                                <span>{person?.name}</span>
                                            </div>
                                            <div title="View Items" onClick={(e)=>{ e.stopPropagation(); setSelectedPersonForCourses(person); setPersonCoursesModalOpen(true); }} className=" flex items-center gap-1 text-color6 cursor-pointer"><IoFastFoodOutline size={20} /> {person?.courses?.length}</div>
                                            <div className=" flex gap-2">
                                                <span 
                                                    title="Remove Assigned Items" 
                                                    onClick={(e)=>{ 
                                                         e.stopPropagation();
                                                        dispatch(movePersonItemsToCourseItems(person.id));

                                                    }} 
                                                    className=" text-orange-500"> <LuListX  size={20} /> </span>
                                                <span
                                                    title=" Delete Person"
                                                    className=" text-color8 ml-2 cursor-pointer"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (person?.courses.length > 0) {
                                                            toast.error("You cannot remove a person who has assigned items. Please remove their items first."); 
                                                            return;
                                                        }
                                                        if (persons.length <= 2) {
                                                            toast.error("You cannot have less than 2 persons."); 
                                                            return;
                                                        }
                                                        dispatch(removePerson(person.id));
                                                        if (selectedPersonId === person.id) setSelectedPersonId("");
                                                    }}
                                                >
                                                    <FaXmark size={20} />
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div>
                            <h2 className={`${isTabletView ? "mt-1.5" : "mt-2"} pb-[1px] font-semibold ${isTabletView ? "text-base" : "text-lg"} text-color6`}> 
                                <span>Course Items </span>  
                                <span>({courseItems.length})</span>
                            </h2>
                            <div className={`w-full ${isTabletView ? "h-[250px]" : "h-[340px]"} overflow-y-auto border-2 border-color3 rounded-md`}>
                                {courseItems.map((item) => {
                                    const checked = selectedCourseItems.some(si => si.front_item_id === item.front_item_id);
                                    return (
                                    <div key={item.front_item_id} className={`w-full flex justify-between items-center bg-color2 ${isTabletView ? "p-1.5 mb-1.5 text-sm" : "p-2 mb-2"} rounded-md`}>
                                        <input type="checkbox" checked={checked} onChange={()=> toggleSelectCourseItem(item)}  name={item.front_item_id} id={item.front_item_id} className=" w-4 h-4 accent-color6" />
                                        <div className=" w-[300px]">
                                            <span>{item.name}</span>
                                            {(item?.variant?.name) && (
                                                <span className=" text-color6"> ({item?.variant?.name})</span>
                                            )}
                                            {(item?.size) && (
                                                <span className=" text-color6"> ({item?.size})</span>
                                            )}
                                            {(item?.buffet_price_for) && (
                                                <span className=" text-color6"> ({item?.buffet_price_for == "kid"? "Kid":"Adult"})</span>
                                            )}
                                        </div>
                                        <div>
                                            <span className=" font-semibold text-color6">£{(parseFloat(withVat(item.calculated_price, item?.vat) || 0)).toFixed(2)}</span>
                                        </div>
                                    </div>
                                    );
                                })}
                            </div>
                            <div>
                                <button
                                    onClick={assignItemsToPerson}
                                    className={`w-full ${isTabletView ? "mt-1.5 px-3 py-2 text-sm" : "mt-2 px-4 py-2"} bg-color12 text-color5 rounded-md font-medium transition-colors hover:opacity-90`}  
                                >
                                    Assign Items to Person
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={`${(isTabletView) ? "w-full" : "w-[33.33%]"} ${(isTabletView && tabPayStep === 1) ? "hidden" : "block"} h-full ${isTabletView ? "pt-4 px-3" : "pt-4 px-4 pb-4"} bg-color3 rounded-md`}>
                        <div className={`w-full ${isTabletView ? "h-[400px]" : "h-[490px]"} overflow-y-auto ${isTabletView ? "p-1.5" : "p-2"} border-2 border-color3 rounded-md`}>
                            {persons.map((person, index) => (
                                <div key={index} className={`w-full flex flex-col bg-color2 items-center ${isTabletView ? "gap-2 mb-4 p-2" : "gap-3 mb-6 p-3"} rounded-md relative`}>
                                    <div className={`w-full ${isTabletView ? "p-1.5" : "p-2"} bg-color3 flex ${isTabletView ? "gap-2" : "gap-4"} rounded-md`}>
                                        <input
                                            type="text"
                                            value={person.name}
                                            onChange={(e) => {
                                                if(is_complete){
                                                    toast.error("Payment is already completed. No further changes allowed.");
                                                    return;
                                                }
                                                dispatch(updatePersonName({ personId: person.id, name: e.target.value }));
                                            }}
                                            className={`w-full ${isTabletView ? "px-2 py-1.5 text-sm" : "px-3 py-2"} bg-color2 border border-gray-600 rounded-md outline-none focus:border-gray-400 placeholder-gray-500`}
                                        />
                                        <span className={`${isTabletView ? "w-[90px] px-1 py-1.5 text-sm" : "w-[110px] px-1 py-2"} bg-color2 text-center border border-gray-600 rounded-md font-medium`}>£{Number(parseFloat(person?.amountToPay || 0) - parseFloat(person?.savingsAmount || 0)).toFixed(2)}</span>
                                    </div>
                                    <div className={`w-full ${isTabletView ? "text-xs" : "text-sm"} text-color6`}>Tips: £{parseFloat(person?.tips?.amount || 0).toFixed(2)}{person?.tips?.type === "percentage" ? ` (${parseFloat(person?.tips?.inputAmount || 0).toFixed(0)}%)` : " (fixed)"}</div>
                                    <div className={`w-full flex ${isTabletView ? "gap-1.5" : "gap-2"}`}>
                                        <button
                                            onClick={() => {
                                                if (!orderData?.id) {
                                                    toast.error("Order not found.");
                                                    return;
                                                }
                                                if (!restaurant_id) {
                                                    toast.error("Restaurant not found.");
                                                    return;
                                                }

                                                printCourseWisePaymentCopy(restaurant_id, orderData.id, person?.id);
                                            }}
                                            className={`grow ${isTabletView ? "px-2 py-1.5 text-sm" : "px-3 py-2"} rounded-md font-medium transition-colors bg-color6 text-white hover:opacity-90`}
                                        >
                                            Print
                                        </button>
                                        <button
                                            onClick={() => {
                                                if(is_complete){
                                                    toast.error("Payment is already completed. No further changes allowed.");
                                                }else{
                                                    setActivePaymentId(person.id); // Set the active payment ID
                                                    setIsModalOpen(true); // Open the modal
                                                }
                                            }}
                                            className={`grow ${isTabletView ? "px-2 py-1.5 text-sm" : "px-3 py-2"} rounded-md font-medium transition-colors bg-cviolet text-white hover:opacity-90`}
                                        >
                                            Cash
                                        </button>
                                        <button
                                            onClick={() => handleOpenCardModal(person)}
                                            className={`grow ${isTabletView ? "px-2 py-1.5 text-sm" : "px-3 py-2"} rounded-md font-medium transition-colors bg-blue-500 text-white hover:opacity-90`}
                                        >
                                            Card
                                        </button>
                                        <button
                                            onClick={()=>{ if(!is_complete){ setTipsFor(person.id); } else { toast.error("Payment is already completed. No further changes allowed."); }}}
                                            className={`grow ${isTabletView ? "px-2 py-1.5 text-sm" : "px-3 py-2"} rounded-md font-medium transition-colors bg-sky-500 text-white hover:opacity-90`}
                                        >
                                            Tips
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={`${(isTabletView) ? "w-full" : "w-[33.33%]"} ${(isTabletView && tabPayStep === 1) ? "hidden" : "block"} flex flex-col ${isTabletView ? " -mt-2" : ""}`}>
                        <div className={`flex items-center justify-between text-center`}>
                            <p className={` uppercase ${isTabletView ? "text-base" : "text-lg"} font-medium`}>TOTAL Item Price</p>
                            <p className={`${isTabletView ? "text-lg" : "text-xl"} font-bold text-color6`}>£{parseFloat(totalAmount || 0).toFixed(2)}</p>
                        </div>
                        <div className={`flex items-center justify-between text-center`}>
                            <p className={` uppercase ${isTabletView ? "text-base" : "text-lg"} font-medium`}>TOTAL Service Charge</p>
                            <p className={`${isTabletView ? "text-lg" : "text-xl"} font-bold text-color6`}>£{totalServiceCharge.toFixed(2)}</p>
                        </div>
                        <div className={`flex items-center justify-between text-center`}>
                            <p className={` uppercase ${isTabletView ? "text-base" : "text-lg"} font-medium`}>TOTAL Savings</p>
                            <p className={`${isTabletView ? "text-lg" : "text-xl"} font-bold text-color6`}>£{parseFloat(orderData ? orderData.total_savings || 0 : 0).toFixed(2)}</p>
                        </div>
                        <div className={`flex items-center justify-between text-center`}>
                            <p className={` uppercase ${isTabletView ? "text-base" : "text-lg"} font-medium`}>TOTAL Tips</p>
                            <p className={`${isTabletView ? "text-lg" : "text-xl"} font-bold text-color6`}>£{calculateTotalTips(persons).toFixed(2)}</p>
                        </div>
                        <div className={`flex items-center justify-between text-center`}>
                            <p className={` uppercase ${isTabletView ? "text-base" : "text-lg"} font-medium`}>TOTAL To Pay</p>
                            <p className={`${isTabletView ? "text-lg" : "text-xl"} font-bold text-color6`}>£{Number(Number(parseFloat(totalToPay).toFixed(2)) + Number(calculateTotalTips(persons).toFixed(2))).toFixed(2)}</p>
                        </div>
                        <div className={`flex items-center justify-between text-center `}>
                            <p className={`${isTabletView ? "text-base" : "text-lg"} font-medium`}>Paid</p>
                            <p className={`${isTabletView ? "text-lg" : "text-xl"} font-bold text-color7`}>
                                £{parseFloat(receivedAmount || 0).toFixed(2)}
                            </p>
                        </div>
                        <div className={`flex items-center justify-between text-center ${isTabletView ? "mb-1" : "mb-2"}`}> 
                            <p className={`${isTabletView ? "text-base" : "text-lg"} font-medium`}>Remaining</p>
                            {
                                Number(Number(parseFloat(remainingAmount || 0).toFixed(2)) > 0) ?
                            
                                <p className={`${isTabletView ? "text-lg" : "text-xl"} font-bold text-color8`}>
                                    £{Number(Number(parseFloat(remainingAmount || 0).toFixed(2)) + Number(calculateTotalTips(persons).toFixed(2))).toFixed(2)}
                                </p>:
                                <p className={`${isTabletView ? "text-lg" : "text-xl"} font-bold text-color8`}>
                                    £{Number(parseFloat(remainingAmount || 0).toFixed(2))}
                                </p>
                            }
                        </div>
                        <div className={`w-full ${isTabletView ? "h-[300px]" : "h-[380px]"} pr-2 overflow-y-auto flex flex-col ${isTabletView ? "gap-2" : "gap-3"}`}>
                            {persons.map((person, index) => (
                                <div key={index} className={`border border-gray-600 rounded-md ${isTabletView ? "p-1.5" : "p-2"}`}>
                                    <p className={`${isTabletView ? "-mt-1 pb-0.5 text-base" : "-mt-2 pb-1 text-lg"} font-medium text-center border-b border-color3`}>{person.name}</p>

                                    <div className={`${isTabletView ? "pt-0.5" : "pt-1"} flex ${isTabletView ? "gap-2" : "gap-4"} justify-between items-center`}>
                                        <p className={`font-semibold ${isTabletView ? "text-sm" : "text-base"}`}>Total Item Price: <span className="text-color6">£{parseFloat(person?.TotalItemPrice || 0).toFixed(2)}</span></p>

                                        <p className={`font-semibold ${isTabletView ? "text-sm" : "text-base"}`}>
                                            <span>Tips </span> 
                                            <span className="text-color6"> £{parseFloat(person?.tips?.amount || 0).toFixed(2)}</span>
                                        </p>   
                                    </div>
                                    <div className={`${isTabletView ? "pt-0.5" : "pt-1"} flex ${isTabletView ? "gap-2" : "gap-4"} justify-between items-center`}>
                                        <p className={`font-semibold ${isTabletView ? "text-sm" : "text-base"}`}>Service Charge: <span className="text-color6">£{person?.serviceCharge?.toFixed(2)}</span></p>
                                        <p className={`font-semibold ${isTabletView ? "text-sm" : "text-base"}`}>Savings: <span className="text-color6">£{parseFloat(person?.savingsAmount || 0).toFixed(2)}</span></p>
  
                                    </div>
                                    <div className={`${isTabletView ? "pt-0.5" : "pt-1"} flex ${isTabletView ? "gap-2" : "gap-4"} justify-between items-center`}>
                                        <p className={`font-semibold ${isTabletView ? "text-sm" : "text-base"}`}>Total To Pay: <span className="text-color6">£{Number(parseFloat(person?.amountToPay || 0) - parseFloat(person?.savingsAmount || 0)).toFixed(2)}</span></p>
                                        <p className={`font-semibold ${isTabletView ? "text-sm" : "text-base"}`}>
                                            Remaining: <span className=" text-color8">£{(
                                                parseFloat(person.amountToPay || 0) -
                                                person.slots.reduce((slotSum, slot) => slotSum + parseFloat(slot.amount), 0) -
                                                parseFloat(person?.savingsAmount || 0)
                                            ).toFixed(2)}</span>
                                        </p>
                                    </div>

                                    {
                                        person.slots.length === 0 ? (
                                            <p className={`text-center ${isTabletView ? "text-xs mt-1" : "text-sm mt-2"} text-color8 italic`}>No slots added yet.</p>
                                        ) : (
                                            <div className="mt-2">
                                                <table className="min-w-full text-sm">
                                                    <thead>
                                                        <tr className="text-left text-color8">
                                                            <th className="py-1 px-2">#</th>
                                                            <th className="py-1 px-2">Method</th>
                                                            <th className="py-1 px-2 text-color6">Received</th>
                                                            <th className="py-1 px-2 text-color7">Amount</th>
                                                            <th className="py-1 px-2 text-color8">Change</th>
                                                            <th className="py-1 px-2"> </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {person.slots.map((slot, slotIndex) => {
                                                            const isCard = (slot.method || "").toLowerCase() === "card";
                                                            const rec = isCard
                                                                ? Number(slot.amount ?? 0)
                                                                : Number(slot.received ?? slot.amount ?? 0);
                                                            const amt = Number(slot.amount ?? 0);
                                                            const chg = isCard
                                                                ? 0
                                                                : Number(slot.changed ?? slot.change ?? Math.max(0, rec - amt));

                                                            return (
                                                                <tr key={slotIndex} className="border-t border-color3">
                                                                    <td className="py-2 px-2">{slotIndex + 1}</td>
                                                                    <td className="py-2 px-2">{slot.method || "N/A"}</td>
                                                                    <td className="py-2 px-2 text-color6">£{rec.toFixed(2)}</td>
                                                                    <td className="py-2 px-2 text-color7">£{amt.toFixed(2)}</td>
                                                                    <td className="py-2 px-2 text-color8">£{chg.toFixed(2)}</td>
                                                                    <td className="py-2 px-2 text-right">{/* actions (optional) */}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={`flex ${isTabletView ? "gap-3 mt-1" : "gap-4 mt-2"}`}>
                    <button
                        onClick={() =>{ dispatch(emptyCourseWisePayState()); setCourseWisePay(false); }}
                        className={`flex-1 bg-red-500 hover:bg-red-600 text-white ${isTabletView ? "py-2.5 text-sm" : "py-2"} rounded-md font-medium transition-colors`}
                    >
                        Close
                    </button>
                    <button
                        onClick={saveCourseWisePay}
                        className={`flex-1 bg-color7 hover:bg-green-600 text-white ${isTabletView ? "py-2.5 text-sm" : "py-2"} rounded-md font-medium transition-colors ${is_complete ? "bg-green-600 cursor-not-allowed" : ""}`}
                    >
                        Save
                    </button>
                </div>
                {isModalOpen && (
                    <DefaultDialog title="Cash Payment" hideButtons={true} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                        <div className="p-4">
                            <div className=" flex gap-4">
                                <div>
                                    <h2 className=" font-bold mb-2">Received</h2>
                                    <input
                                        type="number"
                                        value={cashReceived}
                                        onChange={(e) =>{ setCashReceived(parseFloat(e.target.value) || 0); setCashAmount(parseFloat(e.target.value) || 0); 20}}
                                        className="w-full px-3 py-2 bg-color3 border rounded-md outline-none focus:border-blue-500"
                                        placeholder="Enter amount"
                                    />
                                </div>
                                <div>
                                    <h2 className=" font-bold mb-2">Amount</h2>
                                    <input
                                        type="number"
                                        value={cashAmount}
                                        onChange={(e) => setCashAmount(parseFloat(e.target.value) || 0)}
                                        className="w-full px-3 py-2 bg-color3 border rounded-md outline-none focus:border-blue-500"
                                        placeholder="Enter amount"
                                    />
                                </div>
                                <div>
                                    <h2 className=" font-bold mb-2">Change</h2>
                                    <div className="w-[100px] py-2 flex items-center justify-center bg-color3 border rounded-md "><span>{Number(cashReceived - cashAmount).toFixed(2)}</span></div>
                                </div>
                            </div>
                            <div className="flex justify-end gap-4 mt-4">
                                <button
                                    onClick={() =>{ setIsModalOpen(false); setCashReceived(0); setCashAmount(0); }}
                                    className=" w-full px-4 py-2 bg-color14 rounded-md"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        if (cashReceived > 0) {
                                            dispatch(
                                                addCourseWisePayPersonPaymentSlot({
                                                    personId: activePaymentId,
                                                    slot: { method: "Cash", received: Number(parseFloat(cashReceived).toFixed(2)), amount: Number(parseFloat(cashAmount).toFixed(2)), changed: Number((parseFloat(cashReceived) - parseFloat(cashAmount)).toFixed(2)) },
                                                })
                                            );
                                            setIsModalOpen(false);
                                            setCashReceived(0);
          
                                            // updatePaymentSplit();

                                            setCashReceived(0);
                                            setCashAmount(0);

                                            
                                        } else {
                                            toast.error("Please enter a valid amount.");
                                        }
                                    }}
                                    className={" w-full px-4 py-2 bg-color7 text-white rounded-md "}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </DefaultDialog>
                )}

                {personCoursesModalOpen && selectedPersonForCourses && (
                    <DefaultDialog className=" max-w-[700px]" title={`${selectedPersonForCourses.name} - Items`} hideButtons={true} isOpen={personCoursesModalOpen} onClose={() => setPersonCoursesModalOpen(false)}>
                        <div className="  p-4">
                            <div className=" w-full max-h-[520px] overflow-y-auto">
                                {personForModal?.courses && personForModal.courses.length > 0 ? (
                                    personForModal.courses.map((c, idx) => (
                                        <div key={c.front_item_id || idx} className=" w-full flex justify-between items-center p-2 border-b border-color3">
                                            <div>
                                                <div className="font-medium">
                                                    <span>{c.name}</span>
                                                    {
                                                        c?.variant?.name && (
                                                        <span className=" text-color6"> ({c?.variant?.name})</span>
                                                    )}
                                                    {(c?.size) && (
                                                        <span className=" text-color6"> ({c?.size})</span>
                                                    )}
                                                    {(c?.buffet_price_for) && (
                                                        <span className=" text-color6"> ({c?.buffet_price_for == "kid"? "Kid":"Adult"})</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <div className="text-color6">£{(parseFloat(withVat(c.calculated_price, c.vat)) || 0).toFixed(2)}</div>
                                                <button
                                                    title="Move this item back to Course Items"
                                                    onClick={() => {
                                                        if (!personForModal) return;
                                                        dispatch(movePersonItemToCourseItems({ personId: personForModal.id, front_item_id: c.front_item_id }));
                                                    }}
                                                    className="ml-2 px-2 py-1 text-color14"
                                                >
                                                    <FaXmark size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center text-sm text-color14 italic">No courses assigned.</div>
                                )}
                            </div>
                            <div className="mt-8 -mb-6 flex justify-end gap-2">
                                <button onClick={() => { dispatch(movePersonItemsToCourseItems(selectedPersonForCourses.id)); setPersonCoursesModalOpen(false); }} className=" w-full px-4 py-2 bg-color14 rounded-md text-white">Remove All</button>
                                <button onClick={() => setPersonCoursesModalOpen(false)} className=" w-full px-4 py-2 bg-color7 rounded-md">Close</button>
                            </div>
                        </div>
                    </DefaultDialog>
                )}
                {tipsFor && (
                    <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                        <TipsCourseWiseAndSplit setTipsFor={setTipsFor} tipType={tipType} setTipType={setTipType} amount={amount} setAmount={setAmount} saveTipsInfo={saveTipsInfo} />
                    </div>
                )}

                <SplitCardPaymentConfirmDialog
                    isOpen={!!cardConfirmPerson}
                    onClose={() => setCardConfirmPerson(null)}
                    onConfirm={handleDispatchCardPayment}
                    isLoading={isCardLoading}
                    payment={cardConfirmPerson}
                    maxAmount={cardChargeAmount}
                    orderData={orderData}
                />

                <OrderCardPaymentResponseDialog
                    isOpen={isCardResponseOpen}
                    onClose={() => {
                        setIsCardResponseOpen(false);
                        setCardResponseData(null);
                        setSentCardAmount(0);
                    }}
                    orderId={orderData?.id}
                    responseData={cardResponseData}
                    orderData={orderData}
                    paymentAmount={sentCardAmount}
                    onPaymentCompleted={(res) => {
                        if (res?.data?.course_wise_payment) {
                            dispatch(setCourseWisePayToReduxState(res.data.course_wise_payment));
                        }
                        if (res?.data?.order) {
                            dispatch(setOrderData(res.data.order));
                        }
                    }}
                    onPaymentCancelled={(res) => {
                        if (res?.data?.order) {
                            dispatch(setOrderData(res.data.order));
                        }
                    }}
                />

                <PaxPaymentTimeoutDialog
                    isOpen={isPaxTimeoutDialogOpen}
                    onClose={() => setIsPaxTimeoutDialogOpen(false)}
                    onNewPayment={() => {
                        setIsPaxTimeoutDialogOpen(false);
                        toast("Please select a person/item and click Card to dispatch new payment.");
                    }}
                    orderData={orderData}
                    timeoutData={paxTimeoutData}
                    isLoading={isCardLoading}
                />
            </div>
            )}
        </ErrorBoundary>
    );
}

export default CourseWisePay;